import { SvelteToast, toast } from "@zerodevx/svelte-toast";
import { merge } from "lodash"

new SvelteToast({
    target: document.body,
    props: {
        options: {
            duration: 10000,
            intro: { y: 0, x: 0 },
            positin: 'bottom-right'
        },
    },
});

export const success = (message, props) =>
    toast.push(
        message,
        merge(props, {
            theme: {
                "--toastBackground": "#222222ff",
                "--toastColor": "#ffffff",
                "--toastProgressBackground": "#ffffff",
                "--toastBorderColor": "#222222ff",
            },
        }),
    );

export const warning = (message, props) =>
    toast.push(
        message,
        merge(props, {
            theme: {
                "--toastBackground": "#222222ff",
                "--toastColor": "#ffffff",
                "--toastProgressBackground": "#ffffff",
                "--toastBorderColor": "#222222ff",
            },
        }),
    );

export const failure = (message, props) =>
    toast.push(
        message,
        merge(props, {
            theme: {
                "--toastBackground": "#222222ff",
                "--toastColor": "#ffffff",
                "--toastProgressBackground": "#ffffff",
                "--toastBorderColor": "#222222ff",
            },
        }),
    );
